import React, { Component } from "react";
import ElectronicVerification from "@formatic/electronic-verification";
import AbnLookupComponent from "@formatic/abn-lookup";
import { Overrides } from "@formatic/sdk";

import { ParamsFromURL } from "./components/common";
import OneRegistryLayout from "./layouts/OneRegistry";
import Formatic from "./components/Formatic";

import "@formatic/electronic-verification/dist/bundle.css";

let params;
const formProps = {
  apiServerUrl: "https://api.transformd.com",
  serverUrl: "https://api.transformd.com/graphql",
  subscriptionServerUrl: "wss://api.transformd.com/subscriptions"
};

class App extends Component {
  constructor(props) {
    super(props);
    params = ParamsFromURL();
  }

  render() {
    return (
      <OneRegistryLayout>
        <div className="page__example-fsf">
          <Formatic
            {...formProps}
            formId={439}
            apiKey="DE4eEf83e044538e34AFa1952406d8B92465e24aC8Fc16b5A2B5eDdc5Ea0523d"
            environment="Live"
            channel="master"
            config="default"
            theme="transformd"
            submissionId={params.sessionId}
            runReduxDevTools={process.env.NODE_ENV === "development"}
          >
            <Overrides.OverrideFieldContainer
              type="electronicVerification"
              component={ElectronicVerification}
            />
            <Overrides.OverrideFieldContainer
              component={AbnLookupComponent}
              // this dosnt work but we need this for api
              type="abnLookup"
            />
          </Formatic>
        </div>
      </OneRegistryLayout>
    );
  }
}

export default App;
